/**
 * Date utility functions for appointment time handling
 * Centralized to follow DRY principles
 */

/**
 * Get current time in HH:mm format
 */
export const getCurrentTimeString = (): string => {
  const now = new Date();
  return `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
};

/**
 * Get end of day time (23:59)
 */
export const getEndOfDayTimeString = (): string => '23:59';

/**
 * Extract time string (HH:mm) from Date object or ISO string
 * Returns current time if input is undefined
 */
export const getTimeStringFromDate = (dateInput: Date | string | undefined): string => {
  if (!dateInput) return getCurrentTimeString();
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
};

/**
 * Create a Date object from date string (YYYY-MM-DD) and time string (HH:mm)
 * Uses ISO 8601 format to avoid timezone issues with date-only parsing
 */
export const createDateFromDateAndTime = (dateStr: string, timeStr: string): Date => {
  return new Date(`${dateStr}T${timeStr}`);
};

/**
 * Get today's date in YYYY-MM-DD format
 */
export const getTodayDateString = (): string => {
  return new Date().toISOString().split('T')[0];
};

/**
 * Get date string (YYYY-MM-DD) from a Date object or ISO string
 */
export const getDateString = (dateInput: Date | string): string => {
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  return date.toISOString().split('T')[0];
};
